angular.module('bmsApp.trugreen.quote')
	.controller('TGQuoteViewCtrl', function ($state,
											 $scope,
											 NoteSvc,
											 EmailSvc,
											 $ngBootbox,
											 $filter,
											 notify,
											 TGJobSvc,
											 TGTreatmentSvc) {

		$scope.TGQuoteViewCtrl = {
			pageTitle: 'Quote Overview',
			loading: true,
			isProforma: false,
			quoteId: parseInt($state.params.quoteId),
			quote: null,
			methods: {
				init: function () {
					$scope.TGQuoteViewCtrl.methods.loadQuote();
				},
				addNote: function() {
					var note = {
						object_type: 'App\\Models\\Trugreen\\Job',
						object_id: $scope.TGQuoteViewCtrl.quoteId
					};
					NoteSvc.showSaveModal(note);
				},
				loadQuote: function () {
					$scope.TGQuoteViewCtrl.loading = true;
					TGJobSvc.read($scope.TGQuoteViewCtrl.quoteId)
						.then(function (response) {
							$scope.TGQuoteViewCtrl.job = response.data.tg_job;
							$scope.TGQuoteViewCtrl.isProforma = angular.isObject(response.data.tg_job.enquiry);
							$scope.TGQuoteViewCtrl.loading = false;
							angular.extend($scope, {
								quote: {
									name: angular.copy($scope.TGQuoteViewCtrl.job.quote_name)
								}
							});

							if ($scope.TGQuoteViewCtrl.job.copied) {
								$scope.TGQuoteViewCtrl.methods.calculateCopiedQuoteDifferences();
							}

						});
				},
				calculateCopiedQuoteDifferences: function() {
					var duplicateQuoteTreatments = $scope.TGQuoteViewCtrl.job.duplicate_of.treatments;
					$scope.TGQuoteViewCtrl.hasTreatmentPriceChanges = false;

					angular.forEach($scope.TGQuoteViewCtrl.job.treatments, function(treatment) {
						var duplicatedTreatment = $filter('filter')(duplicateQuoteTreatments, {id: treatment.duplicate_id});

						if (duplicatedTreatment.length == 1) {
							var currentNetPrice = treatment.selling_price_per_treatment;
							var oldNetPrice = duplicatedTreatment[0].selling_price_per_treatment;

							if (currentNetPrice !== oldNetPrice) {
								$scope.TGQuoteViewCtrl.hasTreatmentPriceChanges = true;
								angular.extend(treatment, {
									changed: true,
									newPrice: currentNetPrice,
									oldPrice: oldNetPrice,
									percentDifference: (currentNetPrice - oldNetPrice) / currentNetPrice * 100
								});
							}
							else {
								angular.extend(treatment, {
									changed: false,
									newPrice: currentNetPrice,
									oldPrice: oldNetPrice,
									percentDifference: 0
								})
							}

						}
					});

				},
				getTreatmentAreasList: function (jobTreatment) {
					return TGTreatmentSvc.getTreatmentAreasList(jobTreatment);
				},
				copyQuote: function() {
					TGJobSvc.showCopyQuoteModal($scope.TGQuoteViewCtrl.job).then(function(result) {
						notify({
							message: 'Successfully copied'
						});
						$state.go('main.trugreen.quote.index.view', {quoteId: result.id});
					});
				},
				markAsConfirmed: function() {
					$ngBootbox.confirm('Are you sure you want to mark this quote as confirmed?')
						.then(function () {
								TGJobSvc.markAsConfirmed({id: $scope.TGQuoteViewCtrl.job.id}).then(function (result) {
									notify({
										message: 'Quote marked as confirmed '
									});
								}, function (errors) {
									$scope.TGQuoteViewCtrl.errors = errors;
								});
							}
						);
				},
				deleteQuote: function() {
					$ngBootbox.confirm('Are you sure you want to completely remove this quote?')
						.then(function () {
							TGJobSvc.delete($scope.TGQuoteViewCtrl.job).then(function() {
								notify({
									message: 'Successfully removed quote'
								});
								$state.go('main.trugreen.quote.index');
							},function(errors) {
								$scope.TGQuoteViewCtrl.errors = errors;
							})
						});
				},
				emailForm: function (emailAddress, objectType, objectId) {

					var email = {
						to: emailAddress,
						object_type: objectType,
						object_id: objectId
					};

					EmailSvc.showSendModal(email, $scope.customer);
				}
			},
			tabs: {
				select: {
					notes: function () {
						$scope.note.api.showNotes();
					}
				}
			}
		};



		$scope.TGQuoteViewCtrl.methods.init();

		$scope.note = {
			api: {}
		};

		//$scope.$on('notesUpdated', function () {
		//	setActiveTab('notes');
		//});

	});
